/**
 * ThemeControls — light/dark toggle.
 *
 * Both go through `useTheme()`. Setting the `theme-*` class on <html> by hand
 * does NOT work: ThemeProvider strips any theme class it did not set itself,
 * so your change vanishes on the next render with no error.
 *
 */
import {
  Button,
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  useTheme,
} from '@bloomneo/uikit';
import { Moon, Sun } from 'lucide-react';

export function ThemeControls() {
  const { mode, setMode } = useTheme();

  return (
    <div className="flex items-center gap-0.5">
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            className="size-8"
            aria-label={mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
            onClick={() => setMode(mode === 'dark' ? 'light' : 'dark')}
          >
            {mode === 'dark' ? <Sun className="size-4" /> : <Moon className="size-4" />}
          </Button>
        </TooltipTrigger>
        <TooltipContent>{mode === 'dark' ? 'Light mode' : 'Dark mode'}</TooltipContent>
      </Tooltip>
    </div>
  );
}
